import { useContext } from "react";
import { AppContext } from "./AppContext";
import { useNavigate } from "react-router-dom";
import BaseHomePage from "./components/BaseHomePage";
import { MainHPConfig } from "./configs/MainHPConfig";

function InstantAdHP(props) {
  const setHomePageOrigin = useContext(AppContext).get("setHomePageOrigin");
    const navigate = useNavigate();

    function onLogin(user){
        navigate("/logged");
    }

            return (
    <BaseHomePage
      config={MainHPConfig}
      onLogin={onLogin}
      setHomePageOrigin={setHomePageOrigin}
      pageTitle={MainHPConfig.pageTitle}
      origin={MainHPConfig.origin}
    />
  );
}

export default InstantAdHP;